import { Button, Container, Stack, Text, Title } from "@mantine/core";
import type { FallbackRender } from "@sentry/react";
import * as Sentry from "@sentry/react";

const FallbackComponent: FallbackRender = ({ error, resetError }) => {
	const message =
		error instanceof Error ? error.message : "An unexpected error occurred";
	return (
		<Container size="sm" py="xl">
			<Stack align="center" gap="md">
				<Title order={2}>Something went wrong</Title>
				<Text c="dimmed">{message}</Text>
				<Button onClick={resetError}>Try again</Button>
			</Stack>
		</Container>
	);
};

export function ErrorBoundary({ children }: { children: React.ReactNode }) {
	return (
		<Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
			{children}
		</Sentry.ErrorBoundary>
	);
}
